<div class="integration-card">
    <!-- Banner -->
    <div class="integration-card__banner" [style.background-color]="bannerBgColor">
        <span *ngIf="isConnected && !isLoading" class="integration-card__badge integration-card__badge--connected">{{ 'aumico_companies_integrations_status_connected' | i18next }}</span>
        <span *ngIf="logoClass" class="ham-icon integration-card__logo-icon"><i [class]="logoClass"></i></span>
        <img *ngIf="!logoClass && logoSrc" [src]="logoSrc" [alt]="name" class="integration-card__logo" />
    </div>

    <!-- Body -->
    <div class="integration-card__body">
        <div class="integration-card__text">
            <p class="integration-card__name">{{ name }}</p>
            <p class="integration-card__desc">{{ description }}</p>
        </div>

        <!-- Loading -->
        <ng-container *ngIf="isLoading">
            <button class="integration-card__btn integration-card__btn--primary" disabled>
                {{ 'aumico_companies_integrations_btn_connecting' | i18next }}
            </button>
        </ng-container>

        <!-- Connected -->
        <ng-container *ngIf="isConnected && !isLoading">
            <!-- Sync status (only in syncMode) -->
            <div *ngIf="syncMode" class="integration-card__sync-info">
                <ng-container *ngIf="noMatchingYear">
                    <span class="ham-icon integration-card__sync-icon integration-card__sync-icon--never">
                        <i class="exclamation-outline-icon"></i>
                    </span>
                    <span class="integration-card__sync-label integration-card__sync-label--never">
                        {{ 'aumico_companies_integrations_sync_no_matching_year' | i18next }}
                    </span>
                </ng-container>
                <ng-container *ngIf="!noMatchingYear && lastSyncAt == null">
                    <span class="ham-icon integration-card__sync-icon integration-card__sync-icon--never">
                        <i class="exclamation-outline-icon"></i>
                    </span>
                    <span class="integration-card__sync-label integration-card__sync-label--never">
                        {{ 'aumico_companies_integrations_sync_never' | i18next }}
                    </span>
                </ng-container>
                <ng-container *ngIf="!noMatchingYear && lastSyncAt != null">
                    <span class="integration-card__sync-label integration-card__sync-label--synced">
                        {{ 'aumico_companies_integrations_sync_last' | i18next }} {{ lastSyncAt | dateLocale:0:null:true:true }}
                    </span>
                </ng-container>
            </div>
            <button *ngIf="syncMode" class="integration-card__btn integration-card__btn--primary" [disabled]="noMatchingYear" (click)="syncDataClicked.emit()">
                {{ 'aumico_companies_integrations_btn_sync_data' | i18next }}
            </button>
            <button *ngIf="!syncMode" class="integration-card__btn integration-card__btn--disconnect" (click)="disconnectClicked.emit()">
                {{ 'aumico_companies_integrations_btn_disconnect' | i18next }}
            </button>
        </ng-container>

        <!-- Expired -->
        <ng-container *ngIf="isExpired && !isLoading">
            <span class="integration-card__status integration-card__status--expired">&#9888; {{ 'aumico_companies_integrations_status_expired' | i18next }}</span>
            <button class="integration-card__btn integration-card__btn--primary" (click)="connectClicked.emit()">
                {{ 'aumico_companies_integrations_btn_reconnect' | i18next }}
            </button>
        </ng-container>

        <!-- Not connected -->
        <ng-container *ngIf="!isConnected && !isExpired && !isLoading">
            <button class="integration-card__btn integration-card__btn--primary" (click)="connectClicked.emit()">
                {{ 'aumico_companies_integrations_btn_connect' | i18next }}
            </button>
        </ng-container>
    </div>
</div>
